import { Factory } from 'miragejs';

export default Factory.extend({
  enabled: true,
  body: '',
  duration: 0,
  name: 'Meeting',
  optional: false,
  requiredResign: false,
  sendToBcc: false,
  sendToVisitor: true,
  videoUrl: '',
  requiredOnsite: false,
});
